<script setup lang="ts">
import { useMemberService } from "@/stores/memberFunction/memberService";
import twofourhour from "@image/memberFunction/04/24hour.png";
import cs_photo from "@image/memberFunction/04/cs_photo.png";
import cs_add_bg from "@image/memberFunction/04/cs_add_bg.png";
import line_icon from "@image/memberFunction/04/line_icon.png";
import telegram_icon from "@image/memberFunction/04/telegram_icon.png";
import { onMounted, ref } from "vue";

const showLine = ref(false);
const showTelegram = ref(false);

const lineLink = ref("");
const telegramLink = ref("");

const memberService = useMemberService();

const checkLinks = async () => {
  const res = await memberService.getWebTalkLineService();

  if (res && res.sLink) {
    lineLink.value = res.sLink;
    showLine.value = true;
  } else {
    showLine.value = false;
  }

  if (res && res.sTelegram) {
    telegramLink.value = res.sTelegram;
    showTelegram.value = true;
  } else {
    showTelegram.value = false;
  }
};

// 調整成進入時就發送一次memberService.getWebTalkLineService確認是否有Line或Telegram服務
onMounted(() => {
  checkLinks();
});
</script>

<template>
  <div class="p-5 text-[#fff] mb-5">
    <button type="button">
      <img v-img-src="twofourhour" alt="" class="w-[60%]" />
    </button>
    <div class="flex justify-center items-center mb-5">
      <img v-img-src="cs_photo" alt="" />
    </div>

    <!-- 1 -->
    <div v-if="showLine" class="relative flex justify-around items-center mb-5">
      <img v-img-src="cs_add_bg" alt="" />
      <div
        class="absolute flex justify-evenly gap-x-10 items-center text-[16px] w-[90%] text-[#fff] leading-5"
      >
        <div class="flex justify-around items-center gap-5">
          <img class="w-[35px]" v-img-src="line_icon" alt="" />
          {{ $t("Context.Service.LineService") }}
        </div>
        <a :href="lineLink">
          <button
            class="flex justify-center items-center btn-y-border w-[120px] h-[36px]"
          >
            <div class="text-[16px] text-secondary">
              {{ $t("Context.Service.Join") }}
            </div>
          </button>
        </a>
      </div>
    </div>
    <!-- 2 -->
    <div
      v-if="showTelegram"
      class="relative flex justify-around items-center mb-5"
    >
      <img v-img-src="cs_add_bg" alt="" />
      <div
        class="absolute flex justify-evenly gap-x-10 items-center text-[16px] w-[90%] text-[#fff] leading-5"
      >
        <div class="flex justify-around items-center gap-5 whitespace-nowrap">
          <img class="w-[35px]" :src="telegram_icon" alt="" />
          {{ $t("Context.Service.TelegramService") }}
        </div>
        <a :href="telegramLink">
          <button
            class="flex justify-center items-center btn-y-border w-[120px] h-[36px]"
          >
            <div class="text-[16px] text-secondary">
              {{ $t("Context.Service.Join") }}
            </div>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<style></style>
